import { TeamMemberSuggestion } from "../../types";
import { TeamMemberSuggestionResponse } from "../controllers/teams";

export const convertTeamMemberSuggestionResponse = (
    response: TeamMemberSuggestionResponse
): TeamMemberSuggestion => {
    if (!response) return null;

    const suggestion = new TeamMemberSuggestion();
    suggestion.userId = response.userId;
    suggestion.fullName = response.fullName;
    suggestion.email = response.email;
    suggestion.teamName = response.teamName;

    return suggestion;
};

export const convertTeamMemberSuggestionsResponse = (
    response: TeamMemberSuggestionResponse[]
): TeamMemberSuggestion[] => {
    if (!response) return [];

    return response
        .filter(r => !!r)
        .map(item => convertTeamMemberSuggestionResponse(item));
};
